import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { ArticleEnvironment } from '../environment';
import { ArticleData, DraftArticle } from '../entities';

export class ExternalRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).externalUrl, session, {
      authorization: true,
    });
  }

  getArticle = (nodeId: number | string): SafePromise<ArticleData> => {
    const url = this.URL(`api/articles/${nodeId}/camel`);
    return this.get(url, { allowsAnonymousAuth: true });
  };

  getDraftArticle = (nodeId: number | string, _token?: string): SafePromise<DraftArticle> => {
    const time = new Date().getTime();
    const url = this.URL(`api/articles/draft/${nodeId}`, { time });
    return this.get(url, {
      credentials: 'include',
    });
  };
}
